// src/config/sites.ts

/** Sitio de ciudad para visualizar en el editor 3D */
export interface CitySite {
  id: string;
  name: string;
  lat: number;
  lng: number;
  radius: number;
  /** JSON semilla en public/data/*.json para cargar sin llamar a la API */
  seedUrl?: string;
}

/** Catálogo de sitios disponibles */
export const CITY_SITES: CitySite[] = [
  {
    id: 'parque-la-floresta',
    name: 'Parque de la Floresta',
    lat: 6.2557882,
    lng: -75.6014646,
    radius: 200,
    seedUrl: '/data/floresta_200.json',
  },
  {
    id: 'carlos-e-restrepo',
    name: 'Carlos E Restrepo',
    lat: 6.2568111,
    lng: -75.5783803,
    radius: 300,
    seedUrl: '/data/restrepo_300.json',
  },
  {
    id: 'la-buena-esquina',
    name: 'La Buena Esquina',
    lat: 6.3382197,
    lng: -75.5613524,
    radius: 100,
    seedUrl: '/data/buena_esquina_100.json',
  },
  {
    id: 'el-perpetuo-socorro',
    name: 'El Perpetuo Socorro',
    lat: 6.2363195,
    lng: -75.5731141,
    radius: 600,
    seedUrl: '/data/perpetuo_socorro_600.json',
  },
  {
    id: 'calle-buena-mesa',
    name: 'La Calle de Buena Mesa',
    lat: 6.1774146,
    lng: -75.5858803,
    radius: 200,
    seedUrl: '/data/calle_buena_mesa_200.json',
  },
  {
    id: 'ciudad-del-rio',
    name: 'Ciudad del Rio',
    lat: 6.2214869,
    lng: -75.5733918,
    radius: 800,
    seedUrl: '/data/ciudad_del_rio_800.json',
  },
  {
    id: 'villa-de-aburra',
    name: 'Villa de Aburrá',
    lat: 6.2353117,
    lng: -75.601899,
    radius: 300,
    seedUrl: '/data/villa_aburra_300.json',
  },
  {
    id: 'cabanas-bello',
    name: 'Cabañas Bello',
    lat: 6.3126682,
    lng: -75.5636167,
    radius: 200,
    seedUrl: '/data/cabanas_bello_200.json',
  },
  {
    id: 'mall-otraparte',
    name: 'Mall Otraparte',
    lat: 6.1789317,
    lng: -75.5833632,
    radius: 200,
    seedUrl: '/data/mall_otraparte_200.json',
  },
  {
    id: 'plaza-botero',
    name: 'Plaza Botero',
    lat: 6.2521037,
    lng: -75.5687232,
    radius: 200,
    seedUrl: '/data/plaza_botero_200.json',
  },
  {
    id: 'one-plaza-business-center',
    name: 'One Plaza Business Center',
    lat: 6.2070654,
    lng: -75.5720208,
    radius: 150,
    seedUrl: '/data/one_plaza_150.json',
  },
  {
    id: 'manila',
    name: 'Manila',
    lat: 6.2139158,
    lng: -75.5726417,
    radius: 400,
    seedUrl: '/data/manila_400.json',
  },
  {
    id: 'barrio-obrero',
    name: 'Barrio Obrero',
    lat: 6.3230519,
    lng: -75.5595425,
    radius: 250,
    seedUrl: '/data/barrio_obrero_250.json',
  },
  {
    id: 'lleras',
    name: 'Lleras',
    lat: 6.2089556,
    lng: -75.5678535,
    radius: 900,
    seedUrl: '/data/lleras_900.json',
  },
  {
    id: 'exito-poblado',
    name: 'Éxito Poblado',
    lat: 6.2115294,
    lng: -75.575046,
    radius: 200,
    seedUrl: '/data/exito_poblado_200.json',
  },
  {
    id: 'provenza',
    name: 'Provenza',
    lat: 6.2085129,
    lng: -75.5659769,
    radius: 400,
    seedUrl: '/data/provenza_400.json',
  },
  {
    id: 'primer-parque-laureles',
    name: 'Primer Parque de Laureles',
    lat: 6.2458325,
    lng: -75.5937141,
    radius: 200,
    seedUrl: '/data/primer_parque_laureles_200.json',
  },
  {
    id: 'segundo-parque-laureles',
    name: 'Segundo Parque de Laureles',
    lat: 6.2449485,
    lng: -75.5972237,
    radius: 200,
    seedUrl: '/data/segundo_parque_laureles_200.json',
  },
  {
    id: 'viva-palmas',
    name: 'Viva Palmas',
    lat: 6.1526013,
    lng: -75.5406909,
    radius: 100,
    seedUrl: '/data/viva_palmas_100.json',
  },
  {
    id: 'san-lucas-plaza',
    name: 'San Lucas Plaza',
    lat: 6.1808341,
    lng: -75.5684914,
    radius: 100,
    seedUrl: '/data/san_lucas_plaza_100.json',
  },
  {
    id: 'palmagrande-mall',
    name: 'Palmagrande Mall',
    lat: 6.2204895,
    lng: -75.5666575,
    radius: 100,
    seedUrl: '/data/palmagrande_100.json',
  },
  {
    id: 'mall-palms-avenue',
    name: 'Mall Palms Avenue',
    lat: 6.2174501,
    lng: -75.5651908,
    radius: 100,
    seedUrl: '/data/palms_avenue_100.json',
  },
  {
    id: 'mall-zona-sur',
    name: 'Mall Zona Sur',
    lat: 6.1454529,
    lng: -75.6194568,
    radius: 100,
    seedUrl: '/data/mall_zona_sur_100.json',
  },
  {
    id: 'le-mont-mall',
    name: 'Le Mont Mall',
    lat: 6.1532376,
    lng: -75.5378897,
    radius: 100,
    seedUrl: '/data/le_mont_100.json',
  },
  {
    id: 'amsterdam-plaza',
    name: 'Amsterdam Plaza',
    lat: 6.2014839,
    lng: -75.5566965,
    radius: 100,
    seedUrl: '/data/amsterdam_plaza_100.json',
  },
  {
    id: 'indiana-mall',
    name: 'Indiana Mall',
    lat: 6.1543391,
    lng: -75.5333058,
    radius: 100,
    seedUrl: '/data/indiana_mall_100.json',
  },
  {
    id: 'la-strada',
    name: 'La Strada',
    lat: 6.2018002,
    lng: -75.5720287,
    radius: 100,
    seedUrl: '/data/la_strada_100.json',
  },
  {
    id: 'mall-zona-2-sur',
    name: 'Mall Zona 2 Sur',
    lat: 6.1983546,
    lng: -75.5657972,
    radius: 100,
    seedUrl: '/data/mall_zona2_sur_100.json',
  },
  {
    id: 'primax-la-estacion',
    name: 'Primax La estación',
    lat: 6.1850829,
    lng: -75.578557,
    radius: 100,
    seedUrl: '/data/primex_la_estacion_100.json',
  },
  {
    id: 'mall-bulevar-del-alcazar',
    name: 'Mall Bulevar del Alcázar',
    lat: 6.1538536,
    lng: -75.6123397,
    radius: 400,
    seedUrl: '/data/bulevar_alcazar_400.json',
  },
  {
    id: 'pasaje-cervantes',
    name: 'Pasaje Cervantes',
    lat: 6.2457929,
    lng: -75.563147,
    radius: 300,
    seedUrl: '/data/pasaje_cervantes_300.json',
  },
  {
    id: 'la-castellana',
    name: 'La Castellana',
    lat: 6.2388789,
    lng: -75.6043124,
    radius: 600,
    seedUrl: '/data/la_castellana_600.json',
  },
];

/** Devuelve un sitio por su id (o el primero si no existe) */
export function getSiteById(id: string): CitySite {
  return CITY_SITES.find((s) => s.id === id) ?? CITY_SITES[0];
}